module.exports = "https://static.wmbcdn.com/uniweb/images/438eff778ac57e83e65602c93bfd3a2e.svg";